import { observer } from 'mobx-react-lite';
import PreviewElementChildrenRenderer from './PreviewElementChildrenRenderer';
import type { PreviewElementChildrenRendererProps } from './types';

export type { PreviewElementChildrenRendererProps };
export default observer(PreviewElementChildrenRenderer);
